var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextButton } from '@hn-ui/buttons';
import { Down } from '@hn-ui/icons';
import styled from 'styled-components';
var Button = styled(TextButton).withConfig({ displayName: "Button", componentId: "sc-ty3ylw" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  align-self: center;\n\n  &[aria-pressed='true'] {\n    svg {\n      rotate: 180deg;\n    }\n  }\n"], ["\n  padding: 0;\n  align-self: center;\n\n  &[aria-pressed='true'] {\n    svg {\n      rotate: 180deg;\n    }\n  }\n"])));
var ShowAllButton = function (_a) {
    var studentCount = _a.studentCount, onClick = _a.onClick, toggled = _a.toggled, rest = __rest(_a, ["studentCount", "onClick", "toggled"]);
    return (_jsx(Button, __assign({}, rest, { RightIcon: Down, onClick: onClick, fit: true, "aria-pressed": toggled }, { children: toggled ? 'Hide' : "Show All (" + studentCount + " students)" }), void 0));
};
export { ShowAllButton };
var templateObject_1;
